module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.$t('user.nickname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('user-list-row', {
      key: user.uid,
      attrs: {
        "user": user
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.users.length >= 10),
      expression: "users.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.$t('user.nickname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9801532c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserListTable.vue
// module id = 562
// module chunks = 0